import {UserProfileAttribute} from "../types.ts";

import {useUserProfileAttributesQuery} from "./useUserProfileAttributesQuery.ts";

// FNP-949: the attributes come from React Query. The wide named-attribute
// return shape is preserved exactly - a lot of the portal reads `email`,
// `givenName`, `accountId` and friends off this hook.
//
// These are the signed-in user's Cognito attributes, not a GraphQL list, which
// is why there is no selection or paging here: the module has no table.
export const useUserProfileAttributes = () => {

    const {
        data,
        refetch
    } = useUserProfileAttributesQuery();

    const items = data ?? [];

    const valueOf = (name: string) =>
        items.find((item: UserProfileAttribute) => item.name === name)?.value;

    const sub = valueOf('sub')
    const zoneInfo = valueOf('zoneInfo')
    const givenName = valueOf('givenName')
    const familyName = valueOf('familyName')
    const email = valueOf('email')
    const website = valueOf('website')
    const address = valueOf('address')
    const phoneNumber = valueOf('phoneNumber')
    const profile = valueOf('profile')
    const picture = valueOf('picture')
    const locale = valueOf('locale')
    const nickname = valueOf('nickname')
    const accountId = valueOf('accountId')
    const accountAdmin = valueOf('accountAdmin')
    const gender = valueOf('gender')
    const birthDate = valueOf('birthDate')

    const fetchRecords = async () => {
        refetch()
    };

    return {
        items,
        sub,
        zoneInfo,
        givenName,
        familyName,
        email,
        website,
        address,
        phoneNumber,
        profile,
        picture,
        locale,
        nickname,
        accountId,
        accountAdmin,
        gender,
        birthDate,
        fetchRecords,
    }
}
